<template>
  <div class="details round-corners pa-3 pb-0" :class="darkMode ? 'dark' : ''">
    <h3 class="mb-1 tip-title" :class="breakFooter ? 'display-20-18' : 'display-24-18'">{{ title }}</h3>
    <div class="display-18 preview-text hidden-sm-and-down">{{ previewText }}</div>
    <TipFooter
      :item="item"
      :darkMode="darkMode"
      :breakLine="breakFooter"
      class="tip-footer"
      :class="breakFooter ? 'break' : ''"
    />
  </div>
</template>
 
<script>
import TipFooter from '@/components/Articles/TipFooter'
import { isNil } from 'lodash'
import ArticleLinkVue from './mixins/ArticleLink.js'
import ArticleTitleVue from './mixins/ArticleTitle.js'

export default {
  mixins: [ArticleLinkVue, ArticleTitleVue],
  components: {
    TipFooter
  },
  props: {
    item: {
      type: Object,
      required: false
    },
    darkMode: {
      type: Boolean,
      required: false,
      default: false
    },
    breakFooter: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    previewText() {
      var text = ''
      var rowLength = 90

      if (!isNil(this.item) && !isNil(this.item.text)) {
        if (this.item.text.length > rowLength) {
          text = this.item.text.substring(0, rowLength) + '...'
        } else {
          text = this.item.text
        }
      }

      return text
    }
  }
}
</script>

<style scoped>
.round-corners {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.round-corners.dark {
  width: 100%;
}

.details {
  background-color: #f6f7f9;
  text-align: right;
  line-height: 18px;
  height: 190px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.details .preview-text {
  height: 58px;
  max-height: 58px;
  overflow: hidden;
}

.details.dark {
  background-color: #3e4a54;
  color: #ffffff;
}

.v-card .v-card__text a {
  color: #000;
}

.tip-title {
  height: 60px;
  overflow: hidden;
  font-weight: 400;
  line-height: 1;
}

.tip-footer.break {
  padding-bottom: 8px !important;
}

@media screen and (max-width: 960px) {
  .details {
    height: 130px;
  }

  .tip-title {
    height: 42px;
    overflow: hidden;
  }
}
</style>
